module.exports = __webpack_public_path__ + "img/loginRight.a434ba69.png";